import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-support-policy',
  templateUrl: './support-policy.component.html',
  styleUrls: ['./support-policy.component.scss']
})
export class SupportPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
